var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flip-button",class:{ enabled: _vm.enabled, disabled: _vm.disabled },style:(_vm.headerStyle),on:{"click":_vm.action}},[_vm._v(" "+_vm._s(_vm.isBackwards ? '◄' : '►')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }